// extracted by mini-css-extract-plugin
module.exports = {"container":"FeatureOptions_container__1W3MW","description":"FeatureOptions_description__1cWLR"};